/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import ListView from '../../view/pages/hotel/ListView'
import HotelsStore from '../../store/hotel/HotelsStore'
import HotelAction from '../../action/hotel'
import RoomsStore from '../../store/room/RoomsStore'
import NProgress from 'nprogress'

class HotelsContainer extends Component {
  static getStores() {
    return [HotelsStore, RoomsStore]
  }

  static calculateState(prevState, props) {
    return {
      hotels: HotelsStore.getState(),
      rooms: RoomsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    NProgress.start()
    const id = this.state.match.params.id
    if (id) {
      HotelAction.fetchRoomsById(id)
      NProgress.done()
      return
    }

    HotelAction.fetchAll()
    NProgress.done()
  }

  render() {
    return ListView(this.state)
  }
}

export default withRouter(Container.create(HotelsContainer, { withProps: true }))
